export * from './cards.service';
import { CardsService } from './cards.service';
export * from './param.service';
import { ParamService } from './param.service';
export const APIS = [CardsService, ParamService];
